import ErrorOutline from '@mui/icons-material/ErrorOutline';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

type ShakyErrorIndicatorProps = {
  message: string;
  sx?: SxProps<Theme>;
};

export function ShakyErrorIndicator({ message, sx }: ShakyErrorIndicatorProps) {
  return (
    <Box>
      <Typography
        variant="body2"
        component="span"
        sx={[
          (theme) => ({
            alignItems: 'center',
            color: theme.palette.error.main,
            display: 'flex',
            flex: 0,
            gap: 0.5,
            whiteSpace: 'nowrap',
            '@keyframes shake': {
              '0%': { transform: 'translateX(0)' },
              '25%': { transform: 'translateX(3px)' },
              '50%': { transform: 'translateX(-2px)' },
              '75%': { transform: 'translateX(1px)' },
              '100%': { transform: 'translateX(0)' },
            },
            animation: 'shake .2s linear',
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <ErrorOutline
          sx={(theme) => ({ color: theme.palette.error.main, fontSize: '20px' })}
        />

        {message}
      </Typography>
    </Box>
  );
}
